var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__clip0_16_775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.13 29.722c-9.445-3.073-18.773-4.58-19.825 0L.03 27.76s-1.085-10.356 11.483-6.117c12.567 4.238 16.031.905 16.256-.914.108-.873.53 1.882-.108 4.638-.557 2.4-1.92 4.8-5.004 4.8a8.191 8.191 0 01-2.527-.444zm0-10.284c-9.445-3.073-18.773-4.58-19.825 0L.03 17.474S-1.061 7.121 11.507 11.36c12.568 4.238 16.031.905 16.256-.914.108-.874.53 1.882-.108 4.638-.557 2.401-1.92 4.8-5.004 4.8a8.19 8.19 0 01-2.52-.443v-.003zm0-10.285C10.686 6.086 1.358 4.58.306 9.16L.03 7.195S-1.061-3.154 11.507 1.078c12.568 4.232 16.031.905 16.256-.913.108-.875.53 1.881-.108 4.637-.557 2.401-1.92 4.8-5.003 4.8a8.193 8.193 0 01-2.521-.443v-.006z",
    fill: "url(#logo_svg__paint0_linear_16_775)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint0_linear_16_775",
    x1: 0.007,
    y1: 28.747,
    x2: 32.281,
    y2: 2.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01CCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0172F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__clip0_16_775"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v30.168H0z"
  })))));
}
export default SvgLogo;